import { render, staticRenderFns } from "./SearchbarAutocomplete.vue?vue&type=template&id=10c37483&"
import script from "./SearchbarAutocomplete.vue?vue&type=script&lang=js&"
export * from "./SearchbarAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./SearchbarAutocomplete.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports